import { getPlatform } from './misc';
import { allowBridgeTrackingRecord } from '@/utils/functionController';

// 数据上报
export const trackingRecord = (
  data: ITrackingData = {
    id: '',
    page: '',
    operation: '',
    target: '',
    section: '',
    data: null,
  },
) => {
  if (allowBridgeTrackingRecord()) {
    const platform = getPlatform();
    // 注意：ios 用json object, 安卓用 json string
    (window as MyWindow).WebViewJavascriptBridge.callHandler(
      'trackingRecord',
      platform === 'android' ? JSON.stringify(data) : data,
      (res) => {},
    );
  }
};

export const jump = (url: string, data?: object) => {
  (window as MyWindow).WebViewJavascriptBridge.callHandler(
    'navigate',
    { url, data },
    () => {},
  );
};
